module.exports = __webpack_public_path__ + "static/media/logo178.3923929a.png";